import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TProviderParserFileList } from 'src/store';

import { useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_PROVIDER_PARSER_FILE } from '../../backend-paths';


export const providerParserFileDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_ADMIN_PROVIDER_PARSER_FILE}`,
	(payload: string[], thunkApi) => {
		return HttpService.post(BACKEND_ADMIN_PROVIDER_PARSER_FILE, { items: payload }).then(result => {
			return result.data;
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	isLoading: boolean;
	list: TProviderParserFileList;
	error?: HttpError;
};

const initialState: TInitialState = {
	isLoading: false,
	list: {
		items: [],
		count: 0,
	},
	error: undefined,
};

export const providerParserFileDeleteSlice = createSlice({
	name: 'providerParserFileDeleteSlice',
	initialState,
	reducers: {
		clearProviderParserFileDelete(state) {
			return { ...initialState, list: state.list };
		},
	},

	extraReducers: {
		[providerParserFileDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[providerParserFileDeleteApi.fulfilled.type]: (state, action: PayloadAction<TProviderParserFileList>) => {
			state.isLoading = false;
			state.list = action.payload;
			state.error = undefined;
		},

		[providerParserFileDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProviderParserFileDeleteSelector = () => useAppSelector(state => state[providerParserFileDeleteSlice.name]);

export const { clearProviderParserFileDelete } = providerParserFileDeleteSlice.actions;
